// Implements: F-IDN-015, F-UIX-009
/**
 * Above the access log (v3 `acctAccess`): the Todos / Solo fallidos y bloqueados filter, the period,
 * and the warning with its two links when an attempt was blocked. Pure presentation.
 */

import type { ReactElement } from "react";
import { Link } from "react-router";

import { useTranslation } from "../../../shared/i18n";
import { Icon } from "../../../shared/ui/atoms/Icon";
import { SegmentedControl } from "../../../shared/ui/molecules/SegmentedControl";
import shared from "./account.module.css";

export type AccessFilter = "all" | "bad";

export interface AccessLogToolbarProps {
  readonly filter: AccessFilter;
  readonly onFilter: (filter: AccessFilter) => void;
  readonly anyBlocked: boolean;
  readonly totpEnabled: boolean;
  readonly passwordHref: string;
  readonly totpHref: string;
}

export function AccessLogToolbar(props: AccessLogToolbarProps): ReactElement {
  const { filter, onFilter, anyBlocked, totpEnabled, passwordHref, totpHref } = props;
  const { t } = useTranslation();
  return (
    <>
      <div className={shared.toolbar}>
        <SegmentedControl<AccessFilter>
          label={t("account.access.filterLabel")}
          value={filter}
          onChange={onFilter}
          options={[
            { value: "all", label: t("account.access.all") },
            { value: "bad", label: t("account.access.bad") },
          ]}
        />
        <span className={shared.spacer} />
        <span className={shared.meta}>{t("account.access.period")}</span>
      </div>
      {anyBlocked ? (
        <div className={[shared.notice, shared.spaced].join(" ")}>
          <Icon name="alert-triangle" size="sm" />
          <span>
            {t("account.access.blockedNotice")} {totpEnabled ? `${t("account.access.blockedStopped")} ` : null}
            {t("account.access.blockedIfNotYou")}{" "}
            <Link className={shared.link} to={passwordHref}>
              {t("account.access.changePassword")}
            </Link>
            {totpEnabled ? null : (
              <>
                {" "}
                {t("account.access.blockedAnd")}{" "}
                <Link className={shared.link} to={totpHref}>
                  {t("account.access.enableTotp")}
                </Link>
              </>
            )}
            {t("account.access.sentenceEnd")}
          </span>
        </div>
      ) : null}
    </>
  );
}
